import Vue from 'vue';

const context = require.context('.', true, /(App|Base|Button|Icon)[A-Z][\w-]+\.vue$/);
context.keys().forEach((fileName) => {
  const componentConfig = context(fileName);
  Vue.component(
    fileName.replace(/^.*\//g, '').replace(/\.\w+$/, ''),
    componentConfig.default || componentConfig,
  );
});
